export function normalize(str: string): string {
	return str
		.trim()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
}

export function levenshtein(a: string, b: string): number {
	const an = a.length;
	const bn = b.length;
	const matrix: number[][] = [];

	for (let i = 0; i <= bn; i++) matrix[i] = [i];
	for (let j = 0; j <= an; j++) matrix[0][j] = j;

	for (let i = 1; i <= bn; i++) {
		for (let j = 1; j <= an; j++) {
			const cost = a[j - 1] === b[i - 1] ? 0 : 1;
			matrix[i][j] = Math.min(
				matrix[i - 1][j] + 1,
				matrix[i][j - 1] + 1,
				matrix[i - 1][j - 1] + cost
			);
		}
	}

	return matrix[bn][an];
}

export function similarity(a: string, b: string): number {
	const an = normalize(a);
	const bn = normalize(b);
	if (an === bn) return 1;
	const maxLen = Math.max(an.length, bn.length);
	if (maxLen === 0) return 1;
	const dist = levenshtein(an, bn);
	return 1 - dist / maxLen;
}

export function findBestMatch(
	input: string,
	candidates: string[],
	threshold = 0.7
): string | null {
	const normalized = normalize(input);
	if (!normalized) return null;

	let best = "";
	let bestScore = 0;

	for (const candidate of candidates) {
		const score = similarity(normalized, candidate);
		if (score > bestScore) {
			bestScore = score;
			best = candidate;
		}
	}

	return bestScore >= threshold && best !== input.trim() ? best : null;
}

export function autoCapitalize(input: string): string {
	return input
		.trim()
		.replace(/\s+/g, " ")
		.replace(/\b\w/g, (c) => c.toUpperCase());
}
